import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { setToken } from "../lib/auth";
import { Loader2, Lock } from "lucide-react";

export default function Login() {
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { password: pw });
      setToken(data.token);
      nav("/app");
    } catch (e) {
      setErr("Wrong password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative overflow-hidden bg-[#050505] grain flex items-center justify-center px-6">
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1770795263316-f302a878ee64?crop=entropy&cs=srgb&fm=jpg&q=85')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "blur(8px) saturate(0.6)",
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at center, transparent 0%, #050505 75%)",
        }}
      />

      <div className="relative z-10 w-full max-w-sm">
        <div className="text-center mb-12">
          <div className="text-[10px] tracking-[0.4em] uppercase text-zinc-500 mb-3">
            PROPERTY MOTION AI · INTERNAL TOOL
          </div>
          <h1 className="font-display text-3xl sm:text-4xl text-white font-medium mb-3 whitespace-nowrap">
            Property Motion <span className="text-zinc-600">AI</span>
          </h1>
          <p className="text-zinc-500 text-sm">
            Cinematic real-estate video generator.
          </p>
        </div>

        <form
          onSubmit={submit}
          className="bg-[#0A0A0A] border border-white/10 rounded-2xl p-6"
          data-testid="login-form"
        >
          <label className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-2 block">
            Passphrase
          </label>
          <div className="relative">
            <Lock
              className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-600"
              size={14}
            />
            <input
              type="password"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              placeholder="••••••••••"
              className="w-full bg-white/5 border border-white/10 rounded-lg pl-9 pr-3 py-3 text-white placeholder:text-zinc-600 focus:outline-none focus:border-white/30 transition-all"
              data-testid="login-password-input"
              autoFocus
            />
          </div>
          {err && (
            <div
              className="mt-3 text-xs text-red-400"
              data-testid="login-error"
            >
              {err}
            </div>
          )}
          <button
            type="submit"
            disabled={loading || !pw}
            className="w-full mt-5 bg-white text-black font-medium rounded-lg py-3 hover:bg-zinc-200 active:scale-[0.98] disabled:opacity-40 transition-all flex items-center justify-center gap-2"
            data-testid="login-submit-button"
          >
            {loading ? (
              <Loader2 className="animate-spin" size={16} />
            ) : (
              "Enter Studio"
            )}
          </button>
        </form>

        <div className="text-center mt-6 text-[10px] tracking-[0.3em] uppercase text-zinc-700">
          Powered by Seedance · Magnific
        </div>
      </div>
    </div>
  );
}
